import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "@/App";
import { createQueryClient } from "@/lib/queryClient";
import { applyTheme, getEffectiveTheme } from "@/lib/theme";
import "@/styles/tokens.css";
import "@/styles/globals.css";

applyTheme(getEffectiveTheme());

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

// A single QueryClient lives for the life of the app. React Query
// is our entire client-state store for server data — the auth query
// cache IS the "is the user signed in" signal.
const queryClient = createQueryClient();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
